var map = {
	"./AAP.png": 6440,
	"./ABC.png": 1404,
	"./ACHE.png": 2995,
	"./ACI.png": 2933,
	"./AD.AS.png": 9343,
	"./AHT.L.png": 3678,
	"./ALICORC1.png": 2163,
	"./AMZN.png": 5202,
	"./ASO.png": 5737,
	"./AZO.png": 758,
	"./BBBY.png": 1800,
	"./BBY.png": 1567,
	"./BJ.png": 402,
	"./Belk.png": 7742,
	"./CA.PA.png": 8338,
	"./CENCOSUD.SN.png": 100,
	"./CHWY.png": 9492,
	"./COST.png": 1610,
	"./CTC-A.TO.png": 6768,
	"./DKS.png": 8475,
	"./DLTH.png": 7106,
	"./Distribución y Servicio D&S.png": 7739,
	"./FALABELLA.SN.png": 7946,
	"./FL.png": 3567,
	"./GLORIAI1.png": 6414,
	"./GME.png": 2325,
	"./GOOG.png": 1927,
	"./GPC.png": 9966,
	"./HBC.png": 7699,
	"./HD.png": 1343,
	"./HNNMY.png": 7478,
	"./Highmark.png": 1950,
	"./IMBIQ.png": 2926,
	"./Intercorp Retail.png": 1384,
	"./J. C. Penney Corporation.png": 6105,
	"./JDEP.AS.png": 6410,
	"./JWN.png": 277,
	"./KER.PA.png": 2764,
	"./KR.png": 8674,
	"./KSS.png": 849,
	"./L.TO.png": 4898,
	"./LE.png": 6634,
	"./LEVI.png": 8456,
	"./LIVEPOL1.MX.png": 5703,
	"./M.png": 1054,
	"./MCD.png": 8792,
	"./MKS.L.png": 1102,
	"./MSFT.png": 7599,
	"./Meijer.png": 8662,
	"./Neiman Marcus Group.png": 6786,
	"./ODP.png": 4093,
	"./ORLY.png": 7070,
	"./PARAUCO.SN.png": 9358,
	"./PETM_P.png": 7860,
	"./Petco Animal Supplies Stores.png": 2934,
	"./QUOT.png": 485,
	"./RAD.png": 2379,
	"./RCII.png": 7590,
	"./RIPLEY.SN.png": 2973,
	"./RTMNF.png": 3705,
	"./SBUX.png": 2228,
	"./SHV Holdings N.V..png": 1359,
	"./SIG.png": 6944,
	"./SKX.png": 3978,
	"./STGW.png": 2915,
	"./SVNDF.png": 4311,
	"./Staples.png": 7809,
	"./TGT.png": 1672,
	"./TPR.png": 2539,
	"./Toys R Us Asia.png": 4447,
	"./ULTA.png": 6388,
	"./UNFI.png": 8646,
	"./WCP.TO.png": 1058,
	"./WELX.png": 3090,
	"./WMT.png": 3743,
	"./WN.TO.png": 6326,
	"./WOOF.png": 1819,
	"./White Cap Supply Holdings.png": 7529,
	"./maurices.png": 4754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7294;